// @flow
import type { CreditCardType, ACHMethod } from 'src/redux/reducers/payments'

export const getDefaultPaymentMethod = (methods: (?CreditCardType[] | ACHMethod[])) => methods && methods.find(item => item.default)
